import React, { useState, useEffect, useMemo } from "react"
import { useNavigate } from "react-router-dom"
import Pagination from '../../pages/paginations'
import { Add } from './Add'
import { Edit } from './Edit'
import axiosJWT from '../../JwtToken'

function View() {
    const [msg, setMsg] = useState("")
    const [pesan, setPesan] = useState(false)
    
    const [currentPage, setCurrentPage] = useState(1)
    const [PageSize] = useState(10)
    const [data, setData] = useState([])
    const [add, setAdd] = useState(false)
    const [rowID, setRowID] = useState(false)
    const [edit, setEdit] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        getData('')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getData = async (key) => {
        try {
            const response = await axiosJWT.post("/api/kegiatan-usaha/user", {
                key: key // Ini buat nyaring data di tabel
            })

            setData(response.data)
            setCurrentPage(1) // Balikin ke halaman 1 tiap abis nyari/filter
        } catch (err) {
            // Handle error lebih smooth
            const errorMsg = (err.response && err.response.data && err.response.data.msg)
                || 'Maaf, gagal mengambil data!'
            setMsg(errorMsg)
            setTimeout(() => setMsg(""), 3000)
        }
    }

    const proses = async (id) => {
        try {
            const response = await axiosJWT.delete(`/api/kegiatan-usaha/${id}`)

            getPesan()
            setMsg(response.data.msg) // Munculin "Data berhasil di hapus"

            // Refresh data setelah delay sebentar
            setTimeout(() => {
                getData()
            }, 1000)

            // Hapus notif pesan
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 3000)

        } catch (err) {
            getPesan()
            const errorMsg = (err.response && err.response.data && err.response.data.msg)
                || 'Maaf, proses penghapusan data gagal!'
            setMsg(errorMsg)
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 3000)
        }
    }

    const tableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize
        const lastPageIndex = firstPageIndex + PageSize
        return !data ? [] : data.slice(firstPageIndex, lastPageIndex)
    }, [data, currentPage, PageSize])

    const getPesan = () => {
        setPesan((prevState) => !prevState)
    }

    const display = {
        display: `${pesan ? "block" : "none"}`,
    }

    const openAdd = async () => {
        getAdd()
    }

    const closeAdd = () => {
        getAdd()
    }

    const getAdd = () => {
        setAdd((prevState) => !prevState)
    }

    const displayAdd = {
        display: `${add ? "block" : "none"}`
    }

    const openEdit = async (id) => {
        setRowID(id)
        getEdit()
    }

    const closeEdit = () => {
        setRowID(null)
        getEdit()
    }

    const getEdit = () => {
        setEdit((prevState) => !prevState)
    }

    const displayEdit = {
        display: `${edit ? "block" : "none"}`
    }

    return (<>
        <div className="container">
            <div className="card animated fadeInUp animation-delay-7 br-2 mb-6">
                <div className="card-body p-5">
                    <div className="form-group">
                        <div className="row">
                            <div className="col-md-2 col-xs-4">
                                <button onClick={openAdd} className="btn btn btn-raised btn-primary br-2 no-m">
                                    <i className="fa fa-plus"></i> Tambah
                                </button>
                            </div>
                            <div className="col-md-10 col-xs-8">
                                <input type="text" className="form-control" placeholder="Masukkan Kata Kunci" onChange={(e) => getData(e.target.value)} />
                            </div>
                        </div>
                    </div>
                    <div className="table-responsive">
                        <table className="table table-nomargin dataTable table-bordered data">
                            <thead>
                                <tr className="purple">
                                    <th>No</th>
                                    <th>Nama</th>
                                    <th>Kecamatan</th>
                                    <th>Kelurahan</th>
                                    <th>NPWPD</th>
                                    <th>Proses</th>
                                    <th>Hapus</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableData.map((row, i) => (
                                    <tr key={row._id}>
                                        <td width={"5%"}>{i + 1}</td>
                                        <td width={"35%"}>
                                            {row.name} <br />
                                            {row.isActive ? (
                                                <span className="badge d-inline-block text-wrap badge-success">Sudah Verifikasi</span>
                                            ) : (
                                                <span className="badge d-inline-block text-wrap badge-warning">Pending</span>
                                            )}
                                        </td>
                                        <td width={"15%"}>{row.kecamatan}</td>
                                        <td width={"15%"}>{row.kelurahan}</td>
                                        <td width={"20%"}>{row.npwpd}</td>
                                        <td width={"5%"} className="text-center">
                                            {row.isActive === false ? (<>
                                                <button onClick={() => openEdit(row.potensialCode)} className="btn btn-raised btn-success br-2 no-m">
                                                    <i className="fa fa-pencil no-m"></i>
                                                </button>
                                            </>) : null}
                                        </td>
                                        <td width={"5%"} className="text-center">
                                            {row.isActive === false ? (<>
                                                <button onClick={() => proses(row.potensialCode)} className="btn btn-raised btn-danger br-2 no-m">
                                                    <i className="fa fa-remove no-m"></i>
                                                </button>
                                            </>) : null}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="form-group">
                        <div className="row">
                            <div className="col-md-2 col-xs-6">
                                Ditemukan <b>{data.length}</b> Data
                            </div>
                            <div className="col-md-10 col-xs-6">
                                <Pagination className="pagination-bar text-right" currentPage={currentPage} totalCount={data.length} pageSize={PageSize} onPageChange={page => setCurrentPage(page)} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 col-xs-12">
                            <b>Catatan:</b>
                            <span className="badge d-inline-block text-wrap badge-danger ml-1">Pastikan kembali data yang dikirim, Status Kegiatan Usaha yang telah AKTIF tidak dapat di EDIT dan di HAPUS. Terima kasih.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {add ? (<>
            <div className={add ? ("modal-open") : ("")}>
                <div style={displayAdd} className={add ? 'modal modal-primary show' : 'modal modal-primary'} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                    <div className="modal-dialog review">
                        <div className="modal-content modal-md">
                            <div className="modal-header header-modal-primary p-1">
                                <h4 className="modal-title text-center" id="myModalLabel">Tambah Kegiatan Usaha</h4>
                            </div>
                            <div className="modal-body">
                                <Add getData={getData} closeAdd={closeAdd} getPesan={getPesan} setMsg={setMsg} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>) : ("")}
        {edit ? (<>
            <div className={edit ? ("modal-open") : ("")}>
                <div style={displayEdit} className={edit ? 'modal modal-primary show' : 'modal modal-primary'} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                    <div className="modal-dialog review">
                        <div className="modal-content modal-md">
                            <div className="modal-header header-modal-primary p-1">
                                <h4 className="modal-title text-center" id="myModalLabel">Edit Kegiatan Usaha</h4>
                            </div>
                            <div className="modal-body">
                                <Edit getData={getData} rowID={rowID} closeEdit={closeEdit} getPesan={getPesan} setMsg={setMsg} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>) : ("")}
        <div className={pesan ? "modal-open" : ""}>
            <div style={display} className={pesan ? "modal modal-primary show" : "modal modal-primary"} id="myData" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                <div className="modal-dialog center">
                    <div className="modal-content modal-sm">
                        <div className="modal-header header-modal-primary p-1">
                            <h4 className="modal-title text-center no-p font-bold" id="myModalLabel">
                                PESAN
                            </h4>
                        </div>
                        <div className="modal-body text-center">
                            <h4 className="font-bold">{msg.toUpperCase()}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {pesan ? <div className="modal-backdrop fade in"></div> : ""}
    </>)
}

export default View